@import "tailwindcss";

/*
 * Global background image for the entire site
 */
body {
  background-image: url('/fey-background.png');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
}

/*
 * Color Contrast Ratios (WCAG 2.1 compliance)
 * Requirements: 15.3
 *
 * Background: #1a1a1a (dark)
 *   - White (#ffffff) on dark (#1a1a1a):    ~16:1 ratio ✓ WCAG AAA (≥7:1)
 *   - Gold  (#c9a84c) on dark (#1a1a1a):    ~7:1  ratio ✓ WCAG AA  (≥4.5:1)
 *   - Gray-300 (#d1d5db) on dark (#1a1a1a): ~10:1 ratio ✓ WCAG AAA (≥7:1)
 *
 * All text/background combinations meet WCAG AA minimum contrast requirements.
 */

/* Skip-to-content link — visually hidden until focused (keyboard navigation) */
/* Requirements: 15.4, 15.5 */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.focus\:not-sr-only:focus {
  position: fixed;
  width: auto;
  height: auto;
  padding: 0.5rem 1rem;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

/* Visible focus styles for keyboard navigation */
/* Requirements: 15.4 */
:focus-visible {
  outline: 2px solid #c9a84c;
  outline-offset: 2px;
}

/* Remove focus ring for mouse users (only show for keyboard) */
:focus:not(:focus-visible) {
  outline: none;
}
